import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";

const InspectionsFilterDropdown = ({
  activeButtonSelected,
  toggleDropdownInspections,
}) => {
  const handleOptionSelect = (option) => {
    activeButtonSelected(option);
    toggleDropdownInspections();
  };
  const userRole = localStorage.getItem("user_role");
  const role_condition = userRole === "Admin" || userRole === "Operations";

  return (
    <MenuList style={{ padding: "4px", color: "#000" }}>
      {window.location.pathname.includes("distribution") ? (
        <>
          <MenuItem onClick={() => handleOptionSelect("Opshub")}>
            <ListItemText>Opshub</ListItemText>
          </MenuItem>
          {role_condition && (
            <MenuItem onClick={() => handleOptionSelect("Block Management")}>
              <ListItemText>Block Management</ListItemText>
            </MenuItem>
          )}
        </>
      ) : (
        <>
          <MenuItem onClick={() => handleOptionSelect("Map")}>
            <ListItemText>Map</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => handleOptionSelect("Tracking")}>
            <ListItemText>Tracking</ListItemText>
          </MenuItem>
        </>
      )}
    </MenuList>
  );
};

export default InspectionsFilterDropdown;
